import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { PosmSubitem } from '../../models/posm-subitem.model';



@IonicPage()
@Component({
  selector: 'page-posm-subitem-description',
  templateUrl: 'posm-subitem-description.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PosmSubitemDescriptionPage {

  err: string;
  loading: boolean;

  posmSubitem: PosmSubitem;

  constructor(public storage: Storage, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public modalCtrl: ModalController) {
    if (this.navParams.get('posmSubitem'))
      this.posmSubitem = this.navParams.get('posmSubitem')
  }

  closeModal() {
    this.navCtrl.pop();
  }

  showDescription(posmSubitem) {
    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(PosmSubitemDescriptionPage, {
        posmSubitem: posmSubitem
      }, { cssClass: brand.name });
      tosModal.present();
    });
  }

  ionViewDidLoad() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/posm-subitem-description/posm-subitem-description.ts